export const TabConstants = {
    GET_TAB: 'GET_TAB',
    SET_TAB: 'SET_TAB'
};